var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Error"},[_c('CloseThick',{attrs:{"size":"150px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }